export function isObjectEmpty(obj: any): boolean {

    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }

    return true;
}

export function cloneDeep<T>(arg: T): T {

    // From https://stackoverflow.com/questions/4459928/how-to-deep-clone-in-javascript/
    function clone(obj: any, hash: WeakMap<object, any>) {

        if (Object(obj) !== obj) return obj; // primitives

        if (hash.has(obj)) return hash.get(obj); // cyclic reference

        const result = obj instanceof Set ? new Set(obj)
            : obj instanceof Map ? new Map(Array.from(obj, ([key, val]) => [key, clone(val, hash)]))
                : obj instanceof Date ? new Date(obj)
                    : obj instanceof RegExp ? new RegExp(obj.source, obj.flags)
                        // and finally a catch-all:
                        : obj.constructor ? new obj.constructor()
                            : Object.create(null);

        hash.set(obj, result);

        return Object.assign(
            result,
            ...Object.keys(obj).map(key => ({ [key]: clone(obj[key], hash) }))
        );

    }

    return clone(arg, new WeakMap())

}

export function getProperty(obj: any, properties: string) {

    return properties.split('.').reduce((current, property) => {
        if (current == null) return;
        return current[property];
    }, obj);

}

/**
 * Deletes properties from an object (in place)
 *
 * @param from Target object
 * @param properties Properties to delete
 * @returns "from"
 */
export function deleteProperties<T>(from: T, properties: (keyof T)[]) {

    for (const p of properties) {
        delete from[p]
    }

    return from

}

export function getObjectEntries<T extends {}>(o: T) {

    type Entries = {
        [K in keyof T]: [K, T[K]]
    }[keyof T][]

    const typedEntries = Object.entries(o) as Entries

    return typedEntries

}
